import {
  SITE_URL,
  ORG_NAME,
  ORG_EMAIL,
  ORG_SAME_AS,
  JOHNNY_SAME_AS,
  GHL_SOCIAL_FORM_URL,
  PAGES,
  canonicalUrl,
} from "./pages";
import { FAQ } from "./faq";

const CTX = "https://schema.org";
const ORG_ID = `${SITE_URL}/#organization`;

export const organizationSchema = () => ({
  "@context": CTX,
  "@type": ["Organization", "HealthAndBeautyBusiness"],
  "@id": ORG_ID,
  name: ORG_NAME,
  url: `${SITE_URL}/`,
  logo: `${SITE_URL}/favicon-512x512.png`,
  image: `${SITE_URL}/favicon-512x512.png`,
  email: ORG_EMAIL,
  address: {
    "@type": "PostalAddress",
    addressLocality: "Vancouver",
    addressRegion: "BC",
    addressCountry: "CA",
  },
  areaServed: "Worldwide",
  sameAs: ORG_SAME_AS,
});

export const personSchema = () => ({
  "@context": CTX,
  "@type": "Person",
  "@id": `${SITE_URL}/#johnny-cantiveros`,
  name: "Johnny Cantiveros",
  jobTitle: "Shiva Murti Lineage Teacher",
  worksFor: { "@id": ORG_ID },
  sameAs: JOHNNY_SAME_AS,
});

export const faqSchema = () => ({
  "@context": CTX,
  "@type": "FAQPage",
  mainEntity: FAQ.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const breadcrumbSchema = (crumbs) => ({
  "@context": CTX,
  "@type": "BreadcrumbList",
  itemListElement: crumbs.map((c, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: c.name,
    item: canonicalUrl(c.path),
  })),
});

export const pageCrumbs = (path) =>
  path === "/"
    ? [{ name: "Home", path: "/" }]
    : [{ name: "Home", path: "/" }, { name: PAGES[path].name, path }];

const vancouverOffset = (utcGuess) => {
  const part = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Vancouver",
    timeZoneName: "longOffset",
  })
    .formatToParts(utcGuess)
    .find((p) => p.type === "timeZoneName");
  const off = (part?.value || "GMT").replace("GMT", "");
  return off || "+00:00";
};

export const isoDateTime = (date, time) => {
  const m = /(\d{1,2})(?::(\d{2}))?\s*(am|pm)?/i.exec(time || "");
  if (!date || !m) return date;
  let h = Number(m[1]) % 12;
  if ((m[3] || "").toLowerCase() === "pm") h += 12;
  if (!m[3] && Number(m[1]) === 12) h = 12;
  const min = m[2] || "00";
  const [y, mo, d] = date.split("-").map(Number);
  const offset = vancouverOffset(new Date(Date.UTC(y, mo - 1, d, h + 8, Number(min))));
  return `${date}T${String(h).padStart(2, "0")}:${min}:00${offset}`;
};

export const eventSchema = (ev) => {
  const [street, city = "Vancouver", region = "BC"] = (ev.address || "")
    .split(",")
    .map((s) => s.trim());
  const data = {
    "@context": CTX,
    "@type": "Event",
    name: ev.title,
    description: ev.tagline || undefined,
    startDate: isoDateTime(ev.date, ev.start_time),
    endDate: ev.end_time ? isoDateTime(ev.date, ev.end_time) : undefined,
    eventAttendanceMode: "https://schema.org/OfflineEventAttendanceMode",
    eventStatus: "https://schema.org/EventScheduled",
    location: {
      "@type": "Place",
      name: ev.venue,
      address: {
        "@type": "PostalAddress",
        streetAddress: street,
        addressLocality: city,
        addressRegion: region,
        addressCountry: "CA",
      },
    },
    isAccessibleForFree: true,
    maximumAttendeeCapacity: ev.capacity,
    organizer: { "@type": "Organization", "@id": ORG_ID, name: ORG_NAME, url: `${SITE_URL}/` },
    url: `${SITE_URL}/socials/${ev.slug}`,
    offers: {
      "@type": "Offer",
      price: 0,
      priceCurrency: "CAD",
      availability: "https://schema.org/InStock",
      url: GHL_SOCIAL_FORM_URL,
    },
  };
  return JSON.parse(JSON.stringify(data));
};
